import types from '../mutation-types'
import auth from '../../api/auth'

const state = {
  access_token: sessionStorage.getItem('access_token'),
  refresh_token: sessionStorage.getItem('refresh_token'),
  expires_in: sessionStorage.getItem('expires_in'),
  isLogged: !!sessionStorage.getItem('isLogged')
}

const mutations = {
  [types.LOGIN_USER] (state, data) {
    state.access_token = data.access_token
    state.refresh_token = data.refresh_token
    state.expires_in = data.expires_in
    state.isLogged = true
  },
  [types.LOGOUT_USER] (state) {
    state.access_token = null
    state.refresh_token = null
    state.expires_in = null
    state.isLogged = false
  }
}

const actions = {
  login ({commit}, data) {
    return auth.issueToken(data)
      .then((response) => {
        let data = response.data
        commit(types.LOGIN_USER, data)
        sessionStorage.setItem('access_token', data.access_token)
        sessionStorage.setItem('refresh_token', data.refresh_token)
        sessionStorage.setItem('expires_in', data.expires_in)
        sessionStorage.setItem('isLogged', true)
        return response
      })
  },
  refreshToken ({commit}, data) {
    return auth.refreshToken(data)
      .then((response) => {
        let data = response.data
        commit(types.LOGIN_USER, data)
        sessionStorage.setItem('access_token', data.access_token)
        sessionStorage.setItem('refresh_token', data.refresh_token)
        sessionStorage.setItem('expires_in', data.expires_in)
        sessionStorage.setItem('isLogged', true)
        return response
      })
  },
  logout ({commit}) {
    commit(types.LOGOUT_USER)
    sessionStorage.setItem('access_token', null)
    sessionStorage.setItem('refresh_token', null)
    sessionStorage.setItem('expires_in', null)
    sessionStorage.setItem('isLogged', false)
  }
}

const getters = {}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js